// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b0b87bfb","239":"7dec93fd","455":"d0167418","488":"f963beeb"}[chunkId] + ".chunk.js";
};